export function redirectIndex() {
  window.location.replace("/");
}

export function redirectLogin() {
  if (window.sensors) {
    window.sensors.logout();
  }
  window.location.assign(
    `${process.env.LOGIN_PAGE_URL}?callback=${encodeURIComponent(
      window.location.href
    )}&isSelfDeveloped=true&store=US&locale=en_US&platform=redeem`
  );
}

export function redirectRegister() {
  window.location.assign(
    `${process.env.REGISTER_PAGE_URL}?callback=${encodeURIComponent(
      window.location.href
    )}&isSelfDeveloped=true&store=US&locale=en_US&platform=redeem`
  );
}

export function toEmailVerify(hasOldEmail) {
  window.location.assign(
    `${process.env.EMAIL_VERIFY_PAGE_URL}?callback=${encodeURIComponent(
      window.location.href
    )}&isSelfDeveloped=true&store=US&locale=en_US&hasOldEmail=${hasOldEmail}&platform=redeem`
  );
}



// WEBPACK FOOTER //
// ./src/utils/redirect.js